<template>
  <v-card
    outlined
    class="pb-2 px-1 helmi-card"
    width="100%"
    :class="{ 'mobile' : $vuetify.breakpoint.mdAndUp }"
  >
    <v-card-text>
      <div class="helmi-card-title mb-2">
        Dokumentit
      </div>

      <div class="px-3">
        <v-row>
          <v-list class="mb-0" style="width:100%;">
            <v-list-item
              v-for="(document, idx) in body.attachments"
              :key="idx"
              @click="download(document)"
            >
              <v-list-item-avatar
                class="mr-4"
                color="blue"
              >
                <v-icon dark>
                  description
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-if="document.documentType">
                  {{ documentTypes
                  .find(d => d.documentType === document.documentType)?.description }}
                </v-list-item-title>
                <v-list-item-title v-else-if="document?.description === 'Liite'">
                  Liite {{ idx > 0 ? idx : '' }}
                </v-list-item-title>

                <organization-attachment
                  :document="document"
                  :organizations="organizations"
                />

                <v-list-item-subtitle>
                  {{ document.description }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="!locked">
                <div
                  class="d-flex"
                  style="gap: 6px"
                >
                  <v-btn
                    icon
                    color="primary"
                    small
                    @click.stop="editDocument(document)"
                  >
                    <v-icon size="20">
                      edit
                    </v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    color="primary"
                    small
                    @click.stop="deleteDocument(document.id)"
                  >
                    <v-icon size="20">
                      delete
                    </v-icon>
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              v-if="body.kvpKauppakirjanEsikatselu"
              @click="download(body.kvpKauppakirjanEsikatselu)"
            >
              <v-list-item-avatar
                class="mr-4"
                color="orange"
              >
                <v-icon dark>
                  description
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  Luovutuskirjan esikatselu
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ body.kvpKauppakirjanEsikatselu.description }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="body.kvpKauppakirja"
              @click="download(body.kvpKauppakirja)"
            >
              <v-list-item-avatar
                class="mr-4"
                color="orange"
              >
                <v-icon dark>
                  description
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  Kauppakirja
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ body.kvpKauppakirja.description }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-alert
            v-if="duplicates"
            type="warning"
            text
            dense
            color="red"
            style="width:100%;"
          >
            Liitteillä ei voi olla samaa tyyppiä
          </v-alert>

          <v-alert
            v-for="attachment in missingAttachments"
            :key="attachment.value"
            type="warning"
            text
            color="red"
            style="width:100%;"
            dense
          >
            Yhden liitteistä pitää olla tyypiltään {{ attachment.name }}
          </v-alert>

          <v-alert
            v-if="duplicateFilenames"
            type="warning"
            text
            dense
            color="red"
            style="width:100%;"
          >
            Liitteiden tiedostonimet eivät saa olla samat
          </v-alert>

          <v-alert
            v-if="tradeRegisterExtractsMissing"
            type="warning"
            text
            dense
            color="red"
            style="width:100%;"
          >
            Jokaista yritysosapuolta kohden pitää liittää <b>kaupparekisteriote</b>
          </v-alert>

          <v-alert
            v-if="duplicateTradeRegisterExtracts"
            type="warning"
            text
            dense
            color="red"
            style="width:100%;"
          >
            Kaupparekisteriote-tyyppisiä liitteitä tulee olla vain yksi jokaista yritystä kohden
          </v-alert>

          <v-alert
            v-if="tooManyTradeRegisterExtracts"
            type="warning"
            text
            dense
            color="red"
            style="width:100%;"
          >
            Kaupparekisteriotteita on enemmän kuin yritysosapuolia
          </v-alert>
        </v-row>
      </div>
    </v-card-text>

    <upload v-if="!locked" class="mx-4 mb-2"/>

    <v-dialog
      v-model="editDocumentDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title>Liitteen tyyppi</v-card-title>
        <v-card-text class="pb-0">
          <v-select
            v-model="currentDocument.documentType"
            :items="documentTypes"
            item-text="description"
            item-value="documentType"
            label="Liitteen tyyppi"
          />
          <v-checkbox
            v-if="['RASITUSTODISTUS', 'LAINHUUTOTODISTUS'].includes(currentDocument.documentType)"
            v-model="dateCheck"
            dense
            hide-details
            label="Vahvistan että todistus on päivätty tälle päivälle"
          />

          <organization-selection
            v-if="showOrganizationSelection"
            :selected-organization="currentDocument.businessId"
            :organizations="organizations"
            @change="(val) => { currentDocument.businessId = val; }"
          />
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            :disabled="!isSubmittable"
            color="primary"
            @click="applyDocument()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import download from 'downloadjs'; // eslint-disable-line
import { mapState } from 'vuex';
import { apiGet, apiPost } from '../../api';

export default {
  components: {
    upload: () => import('@/components/DIAS/DIASUpload.vue'),
    'organization-selection': () => import('@/components/DIAS/DIASOrganizationSelection.vue'),
    'organization-attachment': () => import('@/components/DIAS/DIASOrganizationAttachment.vue'),
  },
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    locked: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    dateCheck: false,
    editDocumentDialog: false,
    currentDocument: {},
  }),
  computed: {
    isSubmittable() {
      if (this.showEstateSelection
        && !this.currentDocument.estateSocialSecurityNumber) return false;

      if (this.showOrganizationSelection && !this.currentDocument.businessId) return false;

      if (['RASITUSTODISTUS', 'LAINHUUTOTODISTUS']
        .includes(this.currentDocument.documentType) && !this.dateCheck) return false;

      return true;
    },
    duplicates() {
      if (this.body.attachments?.filter(d => d.documentType === 'LAINHUUTOTODISTUS').length > 1) return true;
      if (this.body.attachments?.filter(d => d.documentType === 'RASITUSTODISTUS').length > 1) return true;
      return false;
    },

    showOrganizationSelection() {
      return [
        'TRADE_REGISTER_EXTRACT',
        'MINUTES_EXTRACT',
      ].includes(this.currentDocument.documentType);
    },

    ...mapState({
      currentProperty: state => state.currentProperty,
    }),
    isRentalLot() {
      return +this.currentProperty.tontinomistus === 1;
    },

    tradeRegisterExtractsMissing() {
      const registerExtractsCount = this.body?.attachments?.filter(d => d.documentType === 'TRADE_REGISTER_EXTRACT').length || 0;

      if (registerExtractsCount < this.organizationsLength) {
        return true;
      }

      return false;
    },

    tooManyTradeRegisterExtracts() {
      const registerExtractsCount = this.body?.attachments?.filter(d => d.documentType === 'TRADE_REGISTER_EXTRACT').length || 0;

      if (registerExtractsCount > this.organizationsLength) {
        return true;
      }

      return false;
    },

    duplicateTradeRegisterExtracts() {
      const registerExtractBusinessIds = this.body?.attachments?.filter(d => d.documentType === 'TRADE_REGISTER_EXTRACT').map(d => d.businessId);

      const organizationBusinessIds = this.organizations.map(o => o.organization.businessId);

      if (organizationBusinessIds.some(id => registerExtractBusinessIds
        .filter(rid => rid === id).length > 1)) {
        return true;
      }

      return false;
    },

    organizationsLength() {
      return this.organizations.length;
    },

    organizations() {
      const organizationSellers = this.body.sellers?.filter(s => s.roles?.some(role => role === 'ORGANIZATION')) || [];
      const organizationBuyers = this.body.buyers?.filter(s => s.roles?.some(role => role === 'ORGANIZATION')) || [];

      return [...organizationSellers, ...organizationBuyers];
    },

    requiredAttachments() {
      return this.isRentalLot ? [{
        name: 'lainhuutotodistus',
        value: 'LAINHUUTOTODISTUS',
      }, {
        name: 'rasitustodistus',
        value: 'RASITUSTODISTUS',
      }, {
        name: 'kantakiinteistön rasitustodistus',
        value: 'KANTAKIINTEISTON_RASITUSTODISTUS',
      }, {
        name: 'vuokrasopimuksen kopio',
        value: 'VUOKRASOPIMUKSEN_KOPIO',
      }, {
        name: 'vuokraoikeustodistus',
        value: 'VUOKRAOIKEUSTODISTUS',
      },
      ] : [{
        name: 'lainhuutotodistus',
        value: 'LAINHUUTOTODISTUS',
      }, {
        name: 'rasitustodistus',
        value: 'RASITUSTODISTUS',
      },
      ];
    },

    documentTypes() {
      let types = this.isRentalLot
        ? [
          {
            description: 'Lainhuutotodistus',
            documentType: 'LAINHUUTOTODISTUS',
          },
          {
            description: 'Rasitustodistus',
            documentType: 'RASITUSTODISTUS',
          },
          {
            description: 'Kantakiinteistön rasitustodistus',
            documentType: 'KANTAKIINTEISTON_RASITUSTODISTUS',
          }, {
            description: 'Vuokrasopimuksen kopio',
            documentType: 'VUOKRASOPIMUKSEN_KOPIO',
          }, {
            description: 'Vuokraoikeustodistus',
            documentType: 'VUOKRAOIKEUSTODISTUS',
          },
          {
            description: 'Muu kauppakirjan liite',
            documentType: 'UNKNOWN',
          },
        ]
        : [
          {
            description: 'Lainhuutotodistus',
            documentType: 'LAINHUUTOTODISTUS',
          },
          {
            description: 'Rasitustodistus',
            documentType: 'RASITUSTODISTUS',
          },
          {
            description: 'Muu kauppakirjan liite',
            documentType: 'UNKNOWN',
          },
        ];

      if (this.organizationsLength > 0) {
        types = [...types, {
          description: 'Kaupparekisteriote',
          documentType: 'TRADE_REGISTER_EXTRACT',
        }, {
          description: 'Pöytäkirjaote',
          documentType: 'MINUTES_EXTRACT',
        }];
      }

      return types;
    },

    missingAttachments() {
      return this.requiredAttachments
        .filter(a => !this.body.attachments?.some(d => d.documentType === a.value));
    },

    duplicateFilenames() {
      const seen = new Set();
      const hasDuplicates = this.body
        .attachments?.some(currentObject => seen.size === seen.add(currentObject.description).size);
      return hasDuplicates;
    },
  },
  created() {
    this.getDocuments();

    this.$bus.$on('GET_DIAS_DOCUMENTS', () => {
      this.getDocuments();
    });
  },
  methods: {
    async deleteDocument(diasId) {
      await apiGet(`dias/deleteByDiasId/${diasId}`);
      // await this.getDocuments(true);
      this.body.attachments = this.body.attachments.filter(i => i.id !== diasId);
    },

    editDocument(document) {
      this.currentDocument = document;
      this.editDocumentDialog = true;
    },

    async applyDocument() {
      this.editDocumentDialog = false;
      this.dateCheck = false;

      const params = {
        id: this.currentDocument.id,
        documentType: this.currentDocument.documentType,
        businessId: this.currentDocument.businessId || '',
      };

      if (!this.showOrganizationSelection) {
        params.businessId = '';
      }

      await apiPost('dias/update-document-type-by-dias-id', params);
    },

    async download(document) {
      const baseURL = process.env.NODE_ENV === 'production'
        ? '/public/backend/api/v1/'
        : 'http://localhost:8888/public/backend/api/v1/';
      const options = {
        method: 'GET',
        credentials: 'include',
      };
      const docResponse = await fetch(`${baseURL}dias/download/${document.id}`, options);
      const doc = await docResponse.arrayBuffer();

      download(doc, document.description, 'application/pdf');
    },
    async getDocuments(refreshAll = false) {
      const docResponse = await apiGet(`dias/documents/${this.$route.params.id}`);

      if (!refreshAll) {
        const currentAttachments = this.body.attachments.map(i => i.id);

        this.body.attachments = [...this.body.attachments, ...docResponse.result.map(item => ({
          description: item.filename,
          documentType: item.documentType || 'UNKNOWN',
          businessId: item.businessId,
          id: item.dias_id,
        })).filter(i => !currentAttachments.includes(i.id))];

        return;
      }

      this.body.attachments = docResponse.result.map(item => ({
        description: item.filename,
        documentType: item.documentType || 'UNKNOWN',
        id: item.dias_id,
      }));
    },
  },
};
</script>
<style scoped>
  .mobile {
    /* min-height:242px; */
    display: flex;
    flex:1;
    justify-content: space-between;
    flex-direction: column;
  }
</style>
